
    import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
    import { mapActions, mapState } from 'vuex';
    import moment from 'moment';
    import { VMenu } from '@/types/Components';
    import {PatientenstatistikStudentenOptions, PreislisteOptions} from '@/store/statistik';

    @Component({
        computed: {
            ...mapState('statistik', ['loaders']),
        },
        methods: {
            ...mapActions('statistik', ['printPreislisten']),
        },
    })
    export default class Patientenstatistik_Studenten extends Vue {
        @Prop() public visible!: boolean;

        public printPreislisten!: (payload: { options: PreislisteOptions }) => void;

        public options: PreislisteOptions = {
            preisliste: 'impfungen_ext_patienten',
        };

        public onClickPrint(): void {
            const options = {
                ...this.options,
            };

            this.printPreislisten({ options });
        }

        public get getTitle() {
            return 'Preisliste';
        }
    }
